import React, { useState } from 'react';

import { connect } from 'react-redux';

import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import BobModal from '../../../components/BobModal';

import * as K2aCoreActions from '../../../actions/k2aCoreActions';

import * as classes from './AddNewEntityModal.module.css';

const ValidationSchema = Yup.object().shape({
    name: Yup.string()
        .required(),
    systemType: Yup.string()
        .required()
});

const AddNewSystemModal = ({
    client,
    createCoreSystem,
    fetchSystems,
    site,
    setIsAddNewSystemModalOpen,
    systemTypes,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);

    const formik = useFormik({
        initialValues: {
            name:       '',
            systemType: ''
        },
        validationSchema:   ValidationSchema,
        enableReinitialize: true,
        onSubmit:           async (values, { setSubmitting }) => {
            const body = {
                siteId:       site.id,
                name:         values.name,
                systemTypeId: values.systemType
            };

            try {
                setIsLoading(true);
                const isCreated = await createCoreSystem(site.id, body);
                setIsLoading(false);
                if (isCreated) {
                    await fetchSystems(site.id);
                    setIsAddNewSystemModalOpen(false);
                }
            } catch (error) {
                setIsLoading(false);
            }
        }
    });

    const MenuProps = {
        disablePortal:      true,
        getContentAnchorEl: () => null,
        PaperProps:         {
            style: {
                maxHeight: 300
            },
        },
    };

    return (
        <BobModal
            title={'Add New System'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setIsAddNewSystemModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.Row}>
                    <div className={classes.Label}>
                        Client
                    </div>
                    <div className={classes.Value}>
                        {client.name}
                    </div>
                </div>
                <div className={classes.BottomRow}>
                    <div className={classes.Label}>
                        Site
                    </div>
                    <div className={classes.Value}>
                        {site.name}
                    </div>
                </div>
                <div>
                    <FormControl className={classes.Row}>
                        <TextField
                            className={classes.Input}
                            id="name"
                            name="name"
                            type="text"
                            value={formik.values.name}
                            label={<span>New System Name<span className={classes.required}> *</span></span>}
                            placeholder="Enter"
                            size="small"
                            onChange={formik.handleChange}
                            InputProps={{
                                onBlur: formik.handleBlur
                            }}
                            variant="outlined"
                            FormHelperTextProps={{
                                classes: {
                                    error: classes.error
                                }
                            }}
                            error={Boolean(formik.errors.name) && Boolean(formik.touched.name)}
                            helperText={Boolean(formik.touched.name) && formik.errors.name}
                        />
                    </FormControl>
                </div>
                <div>
                    <FormControl variant="outlined" size="small" className={classes.Row}>
                        <InputLabel
                            htmlFor="systemType"
                            classes={{
                                error:   classes.error,
                                focused: classes.labelFocused,
                                root:    classes.label
                            }}
                            error={Boolean(formik.errors.systemType) && Boolean(formik.touched.systemType)}
                        >
                            {<span>System Type<span className={classes.required}> *</span></span>}
                        </InputLabel>
                        <Select
                            className={classes.SystemInput}
                            value={formik.values.systemType}
                            id="systemType"
                            MenuProps={MenuProps}
                            onChange={formik.handleChange}
                            name="systemType"
                            classes={{
                                root: classes.input
                            }}
                            inputProps={{
                                onBlur: formik.handleBlur
                            }}
                            error={Boolean(formik.errors.systemType) && Boolean(formik.touched.systemType)}
                        >
                            {
                                systemTypes.map(type =>
                                    <MenuItem
                                        key={type.id}
                                        value={type.id}
                                    >
                                        {type.name}
                                    </MenuItem>
                                )
                            }
                        </Select>
                        {formik.touched.systemType &&
                            formik.errors.systemType && <FormHelperText className={classes.error}>{formik.errors.systemType}</FormHelperText>}
                    </FormControl>
                </div>
                <div className={classes.ButtonContainer}>
                    <BobCancelButton
                        className={classes.CancelButton}
                        disabled={isLoading}
                        onClick={() => setIsAddNewSystemModalOpen(false)}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        className={classes.Buttons}
                        onClick={formik.handleSubmit}
                        label={'Create'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => {
    return {
        systemTypes: state.systemTypes.data
    };
};

const mapDispatchToProps = {
    ...K2aCoreActions
};

export default connect(mapStateToProps, mapDispatchToProps)(AddNewSystemModal);
